const imageCardDark1 = "/assets/cloud/imageCard1.webp";
const imageCardDark2 = "/assets/cloud/imageCard2.webp";
const imageCardDark3 = "/assets/cloud/imageCard3.webp";
const imageCardDark4 = "/assets/cloud/imageCard4.webp";
const imageCardDark5 = "/assets/cloud/imageCard5.webp";
const imageCardDark6 = "/assets/cloud/imageCard6.webp";
const imageCardLight1 = "/assets/cloud/imageCard1-light.webp";
const imageCardLight2 = "/assets/cloud/imageCard2-light.webp";
const imageCardLight3 = "/assets/cloud/imageCard3-light.webp";
const imageCardLight4 = "/assets/cloud/imageCard4-light.webp";
const imageCardLight5 = "/assets/cloud/imageCard5-light.webp";
const imageCardLight6 = "/assets/cloud/imageCard6-light.webp";

const CloudData = [
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "Cloud Infrastructure Setup",
    paragraph:
      "Build scalable, reliable cloud infrastructure tailored to your business requirements, ensuring your systems are always ready for growth.",
  },
  {
    icon: "/assets/cloud/image2.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "Cloud Security & Compliance",
    paragraph:
      "Implement robust security measures and maintain full regulatory compliance, protecting your business and customer data at every level.",
  },
  {
    icon: "/assets/cloud/image3.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "Cloud Migration",
    paragraph:
      "Seamlessly migrate your existing systems to the cloud with zero downtime, ensuring business continuity and minimal disruption.",
  },
  {
    icon: "/assets/cloud/image4.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "DevOps & Automation",
    paragraph:
      "Streamline your development process with automated CI/CD pipelines, accelerating delivery and improving efficiency.",
  },
  {
    icon: "/assets/cloud/image5.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "Multi-Cloud & Hybrid Architecture",
    paragraph:
      "Design flexible, future-proof architectures that integrate multiple cloud providers for maximum adaptability and resilience.",
  },
  {
    icon: "/assets/cloud/image6.svg",
    iconStyles: "w-[87px] h-[81.22px]",
    heading: "Cloud Monitoring & Optimization",
    paragraph:
      "Continuously monitor cloud performance and optimize costs with data-driven insights and intelligent analytics.",
  },
];

const points = [
  { content1: "Scale your infrastructure as your business grows" },
  { content1: "Reduce IT overhead and hardware costs" },
  { content1: "Access services from anywhere, anytime" },
  { content1: "Ensure data security and disaster recovery" },
  { content1: "Automate updates and maintenance" },
];

const ImageCardData = [
  {
    lightImg: imageCardLight1,
    darkImg: imageCardDark1,
    topic: "FinanceTracker Pro",
    text: "Complete financial management platform",
    frameworks: "React + Node.js",
    tag: "AWS",
  },
  {
    lightImg: imageCardLight2,
    darkImg: imageCardDark2,
    topic: "HealthCare Portal",
    text: "Patient management system for clinics",
    frameworks: "Flutter",
    tag: "Serverless",
  },
  {
    lightImg: imageCardLight3,
    darkImg: imageCardDark3,
    topic: "E-Commerce Suite",
    text: "Full-featured online shopping platform",
    frameworks: "React + Node.js",
    tag: "DevOps",
  },
  {
    lightImg: imageCardLight4,
    darkImg: imageCardDark4,
    topic: "LogisticsPro",
    text: "Supply chain management solution",
    frameworks: "React + Node.js",
    tag: "Hybrid",
  },
  {
    lightImg: imageCardLight5,
    darkImg: imageCardDark5,
    topic: "EduLearn Platform",
    text: "Online learning management system",
    frameworks: "React + Node.js",
    tag: "Security",
  },
  {
    lightImg: imageCardLight6,
    darkImg: imageCardDark6,
    topic: "CRM Dashboard",
    text: "Customer relationship management tool",
    frameworks: "React + Node.js",
    tag: "Real Time",
  },
];

export { CloudData, points, ImageCardData };
